(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hf-field-notes"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hf-field-notes]').forEach((gallery) => {
    const track = gallery.querySelector('[data-hf-field-track]');
    const previous = gallery.querySelector('[data-hf-field-prev]');
    const next = gallery.querySelector('[data-hf-field-next]');
    if (!track || !previous || !next) return;
    const update = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll - 1;
    };
    const move = (direction) => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({left: direction * Math.max(240, track.clientWidth * 0.82), behavior: reducedMotion ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), {passive: true});
    window.addEventListener('resize', update, {passive: true});
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
